// 3rd party imports
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { NgModule } from '@angular/core';
import { IhmLoadingIndicatorService } from '../../shared/services/ihm-loading-indicator.service';
// internal imports
import { IhmLoadingIndicatorComponent } from './ihm-loading-indicator.component';

@NgModule({
  imports: [CommonModule],
  declarations: [IhmLoadingIndicatorComponent],
  exports: [IhmLoadingIndicatorComponent]
})
export class IhmLoadingIndicatorModule {
  public static forRoot(useQueueType: boolean = false): ModuleWithProviders {
    return {
      ngModule: IhmLoadingIndicatorModule,
      providers: [{ provide: 'IHM_LOADING_QUEUE_TYPE', useValue: useQueueType }, IhmLoadingIndicatorService]
    };
  }
}
